import React, { Component } from "react";
import DashboardLayout from "../../UI/Layout/DashboardLayout";
import Title from "../../UI/Text/Title";
import Alert from "../../UI/Alert/Alert";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUpload } from "@fortawesome/free-solid-svg-icons";
import { faFileCsv } from "@fortawesome/free-solid-svg-icons";
import Spining from "../../UI/Spining/Spining";
import { HOST_URL, NODE_HOST_URL_v1 } from "../api/Api";
import { Link } from "react-router-dom";
import styles from "./UploadContactList.module.css";

class UploadContactList extends Component {
  constructor(props) {
    super(props);
    const lStorage = JSON.parse(localStorage.getItem("login"));
    const user_id = lStorage.user.userId;
    const token = lStorage.token;
    const list_type = props.match?.params?.list_type;
    const list_name = props.match?.params?.list_name
      ? decodeURIComponent(props.match.params.list_name)
      : "";

    this.state = {
      userId: user_id,
      token: token,
      list_type: list_type,
      list_name: list_name,
      uploadID: "",
      image_url: "",
      isLoading: false,
      setIsLoading: true,
      errorMessage: "",
      messageType: "",
      fileError: "",
      isDragging: false,
      uploadSteps: [],
      currentStep: null,
    };
    this.uploadData = this.uploadData.bind(this);
    this.uploadContactListNew = this.uploadContactListNew.bind(this);
    this.fileChangedHandler = this.fileChangedHandler.bind(this);
  }

  setStep = (label, status = "active") => {
    this.setState((prevState) => {
      const existing = prevState.uploadSteps.find((s) => s.label === label);
      if (existing) {
        // update existing step status
        return {
          uploadSteps: prevState.uploadSteps.map((s) =>
            s.label === label ? { ...s, status } : s
          ),
          currentStep: status === "active" ? label : prevState.currentStep,
        };
      }
      return {
        uploadSteps: [...prevState.uploadSteps, { label, status }],
        currentStep: label,
      };
    });
  };

  deduplicateCSV = (file, onProgress) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = (e) => {
        if (onProgress) onProgress("reading");
        const text = e.target.result;
        const lines = text.split("\n").filter((line) => line.trim() !== "");

        if (lines.length < 2) {
          reject("CSV file is empty or has no data rows.");
          return;
        }

        const header = lines[0];
        const headers = header.split(",").map((h) => h.trim().toLowerCase());

        if (headers[0] !== "country_code" || headers[1] !== "mobile") {
          reject("CSV must have 'country_code' as the first column and 'mobile' as the second column.");
          return;
        }
        if (onProgress) onProgress("deduplicating");

        const mobileIndex = 1;
        const seen = new Set();
        const uniqueRows = [];
        let duplicateCount = 0;

        for (let i = 1; i < lines.length; i++) {
          const cols = lines[i].split(",");
          const mobile = cols[mobileIndex]?.trim();
          if (!mobile) continue;
          if (seen.has(mobile)) {
            duplicateCount++;
          } else {
            seen.add(mobile);
            uniqueRows.push(lines[i]);
          }
        }

        if (onProgress) onProgress("deduplicated");  

        const cleanedCsv = [header, ...uniqueRows].join("\n");
        const blob = new Blob([cleanedCsv], { type: "text/csv" });
        const cleanedFile = new File([blob], file.name, { type: "text/csv" });

        resolve({ cleanedFile, duplicateCount, totalRows: lines.length - 1, uniqueRows: uniqueRows.length });
      };

      reader.onerror = () => reject("Error reading file.");
      reader.readAsText(file);
    });
  };

  uploadData = async () => {
    this.setState({ isLoading: true, isError: false, uploadSteps: [], currentStep: null });
    document.querySelector("body").scrollTo(0, 0);

    try {
      this.setStep("Reading CSV file", "active");

      const { cleanedFile, duplicateCount, totalRows, uniqueRows } = await this.deduplicateCSV(
        this.state.image_url,
        (stage) => {
          if (stage === "reading") {
            this.setStep("Reading CSV file", "done");
            this.setStep("Scanning for duplicates", "active");
          }
          if (stage === "deduplicating") {
            this.setStep("Scanning for duplicates", "active");
          }
          if (stage === "deduplicated") {
            this.setStep("Scanning for duplicates", "done");
          }
        }
      );

      // Show duplicate summary step
      this.setStep(
        duplicateCount > 0
          ? `Removed ${duplicateCount} duplicate(s) — ${uniqueRows} unique contacts`
          : `No duplicates found — ${totalRows} contacts ready`,
        "done"
      );

      this.setStep("Uploading to server…", "active");

      const data = new FormData();
      data.append("csvfile", cleanedFile);
      data.append("user_id", this.state.userId);
      data.append("token", this.state.token);
      data.append("method", "upload");
      data.append("list_id", this.props.match.params.id);

      const result = await fetch(`${HOST_URL}/contact-list.php`, { method: "POST", body: data });
      const resp = await result.json();

      if (resp.success === true) {
        this.setStep("Uploading to server…", "done");
        this.setState({
          isError: true,
          messageType: "alert-success",
          errorMessage: `${resp.message}${duplicateCount > 0 ? ` (${duplicateCount} duplicate(s) removed)` : ""}`,
          isLoading: false,
        });
        setTimeout(() => this.props.history.push("/dashboard/contact-list"), 1500);
      } else {
        this.setStep("Uploading to server…", "error");
        this.setState({
          isError: true,
          messageType: "alert-danger",
          errorMessage: resp.message,
          isLoading: false,
        });
      }
    } catch (err) {
      this.setState({
        isError: true,
        messageType: "alert-danger",
        errorMessage: typeof err === "string" ? err : "Upload failed.",
        isLoading: false,
      });
    }
  };

  uploadContactListNew = async () => {
    this.setState({ isLoading: true, isError: false, uploadSteps: [], currentStep: null });

    try {
      this.setStep("Reading CSV file", "active");

      const { cleanedFile, duplicateCount, totalRows, uniqueRows } = await this.deduplicateCSV(
        this.state.image_url,
        (stage) => {
          if (stage === "reading") {
            this.setStep("Reading CSV file", "done");
            this.setStep("Scanning for duplicates", "active");
          }
          if (stage === "deduplicating") {
            this.setStep("Scanning for duplicates", "active");
          }
          if (stage === "deduplicated") {
            this.setStep("Scanning for duplicates", "done");
          }
        }
      );

      // Show duplicate summary step
      this.setStep(
        duplicateCount > 0
          ? `Removed ${duplicateCount} duplicate(s) — ${uniqueRows} unique contacts`
          : `No duplicates found — ${totalRows} contacts ready`,
        "done"
      );

      this.setStep("Uploading to server…", "active");

      const data = new FormData();
      data.append("file", cleanedFile);
      data.append("user_id", this.state.userId);
      data.append("token", this.state.token);
      data.append("method", "ContactListUpload");
      data.append("list_id", this.props.match.params.id);
      data.append("list_type", this.state.list_type);

      const result = await fetch(`${NODE_HOST_URL_v1}/ContactListUpload`, { method: "POST", body: data });
      const resp = await result.json();

      if (resp.success === true) {
        this.setStep("Uploading to server…", "done");
        this.setState({
          isError: true,
          messageType: "alert-success",
          errorMessage: `${resp.message}${duplicateCount > 0 ? ` (${duplicateCount} duplicate(s) removed)` : ""}`,
          isLoading: false,
        });
        setTimeout(() => this.props.history.push("/dashboard/contact-list"), 1500);
      } else {
        this.setStep("Uploading to server…", "error");
        this.setState({
          isError: true,
          messageType: "alert-danger",
          errorMessage: resp.message,
          isLoading: false,
        });
      }
    } catch (err) {
      this.setState({
        isError: true,
        messageType: "alert-danger",
        errorMessage: typeof err === "string" ? err : "Upload failed.",
        isLoading: false,
      });
    } finally {
      this.setState({ isLoading: false });
    }
  };

  fileChangedHandler(e) {
    const file = e.target.files[0];
    if (!file) return;

    if (!file.name.toLowerCase().endsWith(".csv") && file.type !== "text/csv") {
      this.setState({ image_url: "", fileError: "Only CSV files are allowed." });
      e.target.value = "";
      return;
    }

    // Quick peek at first line to validate columns
    const reader = new FileReader();
    reader.onload = (ev) => {
      const firstLine = ev.target.result.split("\n")[0];
      const headers = firstLine.split(",").map((h) => h.trim().toLowerCase());
      if (headers[0] !== "country_code" || headers[1] !== "mobile") {
        this.setState({
          image_url: "",
          fileError: "CSV must have 'country_code' as column 1 and 'mobile' as column 2.",
        });
        e.target.value = "";
        return;
      }
      this.setState({ image_url: file, fileError: "" });
    };
    reader.readAsText(file);
  }

  clearFile = () => {
    this.setState({ image_url: "", fileError: "" });
    const input = document.getElementById("csv-upload");
    if (input) input.value = "";
  };

  handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  handleDragEnter = (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.setState({ isDragging: true });
  };

  handleDragLeave = (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.setState({ isDragging: false });
  };

  handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.setState({ isDragging: false });
    const file = e.dataTransfer.files[0];
    if (!file) return;
    if (!file.name.toLowerCase().endsWith(".csv") && file.type !== "text/csv") {
      this.setState({ image_url: "", fileError: "Only CSV files are allowed." });
      return;
    }
    this.setState({ image_url: file, fileError: "" });
  };

  render() {
    const { isError, messageType, errorMessage, isLoading, fileError, image_url, isDragging } = this.state;
    const hasFile = !!image_url;

    return (
      <DashboardLayout>
        {isLoading && <Spining />}
        <main className="content">
          <div className="container-fluid p-0">
            <Title isButton={false}>Create Contact List</Title>

            <div className={styles.pageGrid}>

              {/* ── Left: Upload card ── */}
              <div className={styles.uploadCard}>

                {/* Alert at top */}
                {isError && (
                  <Alert type={messageType}>{errorMessage}</Alert>
                )}

                {/* Page title + back button */}
                <div className={styles.pageTopRow}>
                  <div>
                    {this.state.list_name && (
                      <h2 className={styles.listTitle}>{this.state.list_name}</h2>
                    )}
                    <div className={styles.sectionTitle}>Upload Contact CSV</div>
                  </div>
                  <Link to="/dashboard/contact-list" className={styles.backBtn}>
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none"
                      stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"
                      strokeLinejoin="round" aria-hidden="true">
                      <path d="M19 12H5M12 5l-7 7 7 7" />
                    </svg>
                    Back
                  </Link>
                </div>

                {/* Limit banner */}
                {/* <div className={styles.limitBanner}>
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                    strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                    <circle cx="12" cy="12" r="10" />
                    <path d="M12 8v4M12 16h.01" />
                  </svg>
                  Maximum <strong>50,000 contacts</strong> can be uploaded at one time.
                </div> */}

                {/* Drop zone */}
                <label
                  className={[
                    styles.dropZone,
                    hasFile ? styles.dropZoneHasFile : "",
                    fileError ? styles.dropZoneError : "",
                    isDragging ? styles.dropZoneDragging : "",
                  ].filter(Boolean).join(" ")}
                  htmlFor="csv-upload"
                  onDragOver={this.handleDragOver}
                  onDragEnter={this.handleDragEnter}
                  onDragLeave={this.handleDragLeave}
                  onDrop={this.handleDrop}
                >
                  <div className={styles.dropZoneIcon}>
                    <FontAwesomeIcon icon={faFileCsv} />
                  </div>
                  {hasFile ? (
                    <div className={styles.dropZoneFileName}>{image_url.name}</div>
                  ) : isDragging ? (
                    <>
                      <div className={styles.dropZoneText}>Drop your CSV file here</div>
                      <div className={styles.dropZoneHint}>Release to attach the file</div>
                    </>
                  ) : (
                    <>
                      <div className={styles.dropZoneText}>Drag & drop or click to choose a CSV file</div>
                      <div className={styles.dropZoneHint}>Only .csv files are accepted</div>
                    </>
                  )}
                  <input
                    id="csv-upload"
                    type="file"
                    accept=".csv,text/csv"
                    onChange={this.fileChangedHandler}
                    className={styles.hiddenInput}
                  />
                </label>

                {/* File validation error */}
                {fileError && (
                  <div className={styles.fileError}>
                    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10" /><path d="M12 8v4M12 16h.01" /></svg>
                    {fileError}
                  </div>
                )}

                {/* Sample download */}
                <div className={styles.sampleRow}>
                  <span className={styles.sampleText}>Need a sample file?</span>
                  <a
                    href="/uploadContact.csv"
                    download
                    target="_blank"
                    rel="noopener noreferrer"
                    className={styles.sampleLink}
                  >
                    <FontAwesomeIcon icon={faFileCsv} />
                    Download sample CSV
                  </a>
                </div>
                {/* ── Upload Progress Steps ── */}
                {this.state.uploadSteps.length > 0 && (
                  <div className={styles.progressSteps}>
                    {this.state.uploadSteps.map((step, i) => (
                      <div
                        key={i}
                        className={[
                          styles.progressStep,
                          step.status === "done" ? styles.progressStepDone : "",
                          step.status === "active" ? styles.progressStepActive : "",
                          step.status === "error" ? styles.progressStepError : "",
                        ].filter(Boolean).join(" ")}
                      >
                        <span className={styles.progressDot}>
                          {step.status === "done" ? (
                            // checkmark
                            <svg width="11" height="11" viewBox="0 0 24 24" fill="none"
                              stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                              <polyline points="20 6 9 17 4 12" />
                            </svg>
                          ) : (
                            // spinner dot
                            <span className={styles.progressSpinner} />
                          )}
                        </span>
                        <span className={styles.progressLabel}>{step.label}</span>
                      </div>
                    ))}
                  </div>
                )}

                {/* Upload button */}
                <div className={styles.uploadBtnWrap}>
                  {hasFile && (
                    <button
                      type="button"
                      className={styles.cancelBtn}
                      onClick={this.clearFile}
                      disabled={isLoading}
                    >
                      Discard File
                    </button>
                  )}
                  <button
                    onClick={this.state.list_type === "contact" ? this.uploadData : this.uploadContactListNew}
                    className={styles.uploadBtn}
                    disabled={!hasFile || !!fileError || isLoading}
                  >
                    <FontAwesomeIcon icon={faUpload} />
                    {isLoading ? "Uploading…" : "Upload"}
                  </button>
                </div>
              </div>

              {/* ── Right: Notes card ── */}
              <div className={styles.notesCard}>
                <div className={styles.notesTitle}>Notes</div>
                <ol className={styles.notesList}>
                  <li>While uploading the CSV, pass the sender ID as <strong>null</strong> if you want to use the template ID for all approved sender IDs.</li>
                  <li>During the CSV upload, always use the approved sender ID. Otherwise, don't use it when sending SMS.</li>
                  <li>When uploading the CSV, don't remove the first row of the sample file.</li>
                </ol>
              </div>

            </div>
          </div>
        </main>
      </DashboardLayout>
    );
  }
}

export default UploadContactList;